<template>
    <form-fields>
        <toolbar-buttons>
            <icon-button
                :label="$t('V3_ALIGN_LEFT')"
                @click="alignLeft"
            >
                <img src="../../assets/v2/align-horizontal-left.svg" />
            </icon-button>

            <icon-button
                :label="$t('V3_ALIGN_HCENTER')"
                @click="alignHCenter"
            >
                <img src="../../assets/v2/align-horizontal-center.svg" />
            </icon-button>

            <icon-button
                :label="$t('V3_ALIGN_RIGHT')"
                @click="alignRight"
            >
                <img src="../../assets/v2/align-horizontal-right.svg" />
            </icon-button>

            <icon-button
                :label="$t('V3_ALIGN_TOP')"
                @click="alignTop"
            >
                <img src="../../assets/v2/align-vertical-top.svg" />
            </icon-button>

            <icon-button
                :label="$t('V3_ALIGN_VCENTER')"
                @click="alignVCenter"
            >
                <img src="../../assets/v2/align-vertical-center.svg" />
            </icon-button>

            <icon-button
                :label="$t('V3_ALIGN_BOTTOM')"
                @click="alignBottom"
            >
                <img src="../../assets/v2/align-vertical-bottom.svg" />
            </icon-button>
        </toolbar-buttons>

        <step-buttons
            :class="{
                'cz3__hide-lg': buttonsSm,
            }"
        >
            <secondary-button
                class="cz3__flex-1"
                :label="$t('V3_BACK')"
                @click="back"
            />

            <action-button
                class="cz3__flex-1"
                :label="$t('V3_NEXT')"
                @click="next"
            />
        </step-buttons>
    </form-fields>
</template>

<style lang="scss">
</style>

<script>
    import ToolbarButtons from './ToolbarButtons.vue';
    import IconButton from './IconButton.vue';
    import FormFields from './FormFields.vue';
    import ActionButton from './ActionButton.vue';
    import SecondaryButton from './SecondaryButton.vue';
    import StepButtons from './StepButtons.vue';

    import designArea from '../../utilities/designArea';
    import extent from '../../utilities/extent';

    export default {
        components: {
            ToolbarButtons,
            IconButton,
            FormFields,
            ActionButton,
            SecondaryButton,
            StepButtons,
        },

        props: {
            buttonsSm: Boolean,
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            editPlacements() {
                return this.$store.state.customizer.editPlacements;
            },

            editPlacement() {
                if (this.editPlacements && this.editPlacements.length > 0) {
                    return this.editPlacements[0];
                }

                return null;
            },

            editComponent() {
                if (this.editPlacement) {
                    return this.viewController.selectedAtPlacement(this.editPlacement.code);
                }

                return null;
            },

            personalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },

            nextStep() {
                return this.$store.getters.nextStepV3;
            },
        },

        methods: {
            back() {
                this.$store.dispatch('setSelectedSubStepV3', 'upload');
            },

            next() {
                if (this.nextStep) {
                    this.$store.dispatch('setSelectedStepV3', this.nextStep);
                }
            },

            /**
             * Align the image to the left.
             */
            alignLeft() {
                const { left } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                if (left != null) {
                    const { dx } = extent(this.editPlacement, this.editComponent);

                    this.viewController.commitCustomAttributes(this.editPlacement.code, {
                        'dynamic-image-offset-x': left + dx,
                    });
                }
            },

            /**
             * Align the image to the center.
             */
            alignHCenter() {
                const { left, right } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                if (left != null && right != null) {
                    this.viewController.commitCustomAttributes(this.editPlacement.code, {
                        'dynamic-image-offset-x': ((left + right) * 0.5),
                    });
                }
            },

            /**
             * Align the image to the right.
             */
            alignRight() {
                const { right } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                if (right != null) {
                    const { dx } = extent(this.editPlacement, this.editComponent);

                    this.viewController.commitCustomAttributes(this.editPlacement.code, {
                        'dynamic-image-offset-x': right - dx,
                    });
                }
            },

            /**
             * Align the image to the top.
             */
            alignTop() {
                const { top } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                if (top != null) {
                    const { dy } = extent(this.editPlacement, this.editComponent);

                    this.viewController.commitCustomAttributes(this.editPlacement.code, {
                        'dynamic-image-offset-y': top + dy,
                    });
                }
            },

            /**
             * Align the image to the center.
             */
            alignVCenter() {
                const { top, bottom } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                if (top != null && bottom != null) {
                    this.viewController.commitCustomAttributes(this.editPlacement.code, {
                        'dynamic-image-offset-y': (top + bottom) * 0.5,
                    });
                }
            },

            /**
             * Align the image to the bottom.
             */
            alignBottom() {
                const { bottom } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                if (bottom != null) {
                    const { dy } = extent(this.editPlacement, this.editComponent);

                    this.viewController.commitCustomAttributes(this.editPlacement.code, {
                        'dynamic-image-offset-y': bottom - dy,
                    });
                }
            },
        },
    };
</script>
